'use strict' /* eslint-disable no-console */;

import axios from 'axios';

import actions from './actions';

import { FETCH_COMMENTS } from './mutations';
import { POST_COMMENT } from './mutations';
import { DELETE_COMMENT } from './mutations';
import { UPDATE_COMMENT } from './mutations';

// API doesn't accept X-CSRF-TOKEN as a header for now.
axios.defaults.headers.common = {
  'Content-Type': 'application/json',
  Accept: 'application/json, text/json, application/xml, text/xml',
};

// const store = new Vuex.Store({
const state = {
  comments: [],
  productId: '',
  API_ENDPOINT: '',
  showAll: false,
  activeConnections: 'all',
  activeExperiences: 'all',
  activeTags: [],
  commentEdit: {
    isEditing: false,
    isNew: true,
    comment: {},
  },
};

const getters = {
  filteredComments: state => {
    return state.comments
      .filter(comment => {
        if (state.activeExperiences == 'all') {
          return true;
        }
        return comment.Experience == state.activeExperiences;
      })
      .filter(comment => {
        if (state.activeConnections == 'all') {
          return true;
        }
        return comment.Connection == state.activeConnections;
      })
      .filter(comment => {
        return comment.ReviewText !== '' && comment.ReviewText !== null;
      });
  },
};

const mutations = {
  setProductId(state, productId) {
    state.productId = productId;
    state.API_ENDPOINT = `${window.ConcordConfig
      .env}/api/v1/customer-experience/${productId}`;
  },

  updateExperiences(state, value) {
    state.activeExperiences = value;
  },

  updateConnections(state, value) {
    state.activeConnections = value;
  },

  showAllComments(state) {
    state.showAll = true;
  },

  updateCommentEditState(state, payload) {
    state.commentEdit.comment = payload || {};
  },

  toggleComments(state) {
    state.commentEdit.isEditing = !state.commentEdit.isEditing;
  },

  [FETCH_COMMENTS](state, { data }) {
    // approved comments are filtered via the authorized user.
    // pending items will show if the current user has created them.
    state.comments = [...data];
  },

  /**
  * Deprecated
  */
  [POST_COMMENT](state, { data }) {
    const json = JSON.parse(data);
    state.comments.push(json);
  },

  /**
  * Deprecated
  */
  [UPDATE_COMMENT](state, { data }) {
    // console.log(data);
    state.comments.push(...data);
  },

  /**
  * Deprecated
  */
  [DELETE_COMMENT]() {
    // console.log(data, index);
    // state.comments.slice(index, 1);
  },
};

const commentsModule = {
  // namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default commentsModule;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/comments/store.js